import React, {useEffect, useState} from 'react';
import AppMenu from "../../app/components/AppMenu";
import {useAppDispatch, useAppSelector} from "../../app/hooks";
import {getUser} from "../auth/auth.slice";
import {Embed, IReportEmbedConfiguration, models} from 'powerbi-client';
import {PowerBIEmbed} from "powerbi-client-react";
import './Dashboard.css';

function Dashboard() {
    const authState = useAppSelector((state) => state.auth);
    const dispatch = useAppDispatch();
    const [embedConfig, setEmbedConfig] = useState<IReportEmbedConfiguration | undefined>();
    const [report, setReport] = useState<Embed | null>(null);

    useEffect(() => {
        dispatch(getUser())
    }, [])
    useEffect(() => {
        if (authState.currentClient) {
            setEmbedConfig({
                type: 'report', // Supported types: report, dashboard, tile, visual, and qna.
                id: authState.currentClient.embedConfig.reportConfig[0].reportId,
                embedUrl: authState.currentClient.embedConfig.reportConfig[0].embedUrl,
                accessToken: authState.currentClient.embedConfig.accessToken,
                tokenType: models.TokenType.Embed, // Use models.TokenType.Aad if you're embedding for your organization.
                settings: {
                    panes: {
                        filters: {
                            expanded: false,
                            visible: false
                        },
                        pageNavigation: {
                            visible: false
                        }
                    },
                    background: models.BackgroundType.Default,
                }
            })

        }
    }, [authState.currentClient?.id])

    useEffect(() => {
        if (report) {
            report.reload()
        }
    }, [embedConfig])
    return (
        <div style={{height: '100vh'}}>
            <AppMenu/>
            {embedConfig?.type?<PowerBIEmbed embedConfig={embedConfig}
              eventHandlers = {
                  new Map([
                      ['loaded', function () {console.log('Report loaded');}],
                      ['rendered', function () {console.log('Report rendered');}],
                      ['error', (event:any) => {console.log(event.detail);}]
                  ])
              }
              cssClassName = { "report-style-class" }
              getEmbeddedComponent = { (embeddedReport: Embed) => {
                  setReport(embeddedReport);
              }}
            />:<br/>}

        </div>
    );
}

export default Dashboard;
